import { render, staticRenderFns } from "./RequestQuote.vue?vue&type=template&id=4b163f56&scoped=true&"
import script from "./RequestQuote.vue?vue&type=script&lang=ts&"
export * from "./RequestQuote.vue?vue&type=script&lang=ts&"
import style0 from "./RequestQuote.vue?vue&type=style&index=0&id=4b163f56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b163f56",
  null
  
)

export default component.exports